import { ArrayInput, DateTimeInput, Edit, ReferenceOneField, SimpleForm, SimpleFormIterator, TextInput, SelectInput, NumberInput } from 'react-admin';

const statusOptions = [
  { id: 'free', name: 'Free' },
  { id: 'trialing', name: 'Trialing' },
  { id: 'active', name: 'Active' },
  { id: 'canceled', name: 'Canceled', not_available: true },
  { id: 'incomplete', name: 'Incomplete', not_available: true },
  { id: 'incomplete_expired', name: 'Incomplete_expired', not_available: true },
  { id: 'past_due', name: 'Past_due', not_available: true },
  { id: 'unpaid', name: 'Unpaid', not_available: true },
  { id: 'deleted', name: 'Deleted', not_available: true }
];

const featureOptions = [
  { id: 'ta', name: 'Time&Attendance' },
  { id: 'projects', name: 'Projects' },
  { id: 'shifts', name: 'Shifts' }
];

export const CustomerEdit = () => (
  <Edit redirect="show">
    <SimpleForm>
      <TextInput disabled label="Id" source="id" />
      <TextInput disabled source="name" />
      <TextInput disabled source="email" />
      <TextInput disabled source="externalId" label="External ID" />
      <TextInput disabled source="location.code" />
      <ReferenceOneField reference="organizations" source="organizationUuid" target="uuid">
        <TextInput disabled source="name" />
      </ReferenceOneField>
      <ArrayInput source="subscriptions">
        <SimpleFormIterator disableReordering disableAdd disableRemove>
          <TextInput disabled source="uuid" label="Uuid" />
          <TextInput disabled source="externalId" label="External ID" />
          <SelectInput source="status" choices={statusOptions} disableValue="not_available" />
          <DateTimeInput disabled source="startedAt" label="StartedAt" />
          <DateTimeInput disabled source="endedAt" label="EndedAt" />
          <DateTimeInput disabled source="currentPeriodStartedAt" label="currentPeriodStartedAt" />
          <DateTimeInput disabled source="currentPeriodEndedAt" label="currentPeriodEndedAt" />
          <DateTimeInput disabled source="trialStartedAt" label="trialStartedAt" />
          <DateTimeInput source="trialEndedAt" label="TrialEndedAt" />
          <ArrayInput source="items">
            <SimpleFormIterator disableReordering>
              <TextInput disabled source="uuid" label="Uuid" />
              <SelectInput source="feature" choices={featureOptions} label="Feature" />
              <NumberInput source="maxSeats" label="Max Seats" />
            </SimpleFormIterator>
          </ArrayInput>
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Edit>
);
